module.exports = __webpack_public_path__ + "media/images/footer-logo-1447fdc4641fc36f8da8aa104d4128a5.svg";